import { LocaleKeys } from '../../locale/translation-types'
import { OLTypeEnum } from '../types/enums/ol/ol-type.enum'
import { ProductTypeEnum } from '../types/enums/product/product-type.enum'
import { RoleEnum } from '../types/enums/users/role.enum'
import { Paths } from './path'

type OlPermissionKeys =
  | 'ol-personal-space'
  | 'center-costs-ol-payments'
  | 'center-costs-local-organizers'
  | 'center-costs-host-family'
  | 'center-costs-tefl'
  | 'center-costs-teaching-hall'
  | 'center-costs-cultural-outings'
  | 'center-costs-arrival-departure-transfers'
  | 'center-costs-french-leader'
  | 'center-costs-activities'
  | 'ol-teaching-hall-quotation'
  | 'ol-teaching-hall-assignment-history'
  | 'center-costs-miscellaneous'
  | 'center-costs-total-costs'
  | 'center-events'
  | 'center-costs-status'
  | 'center-program-and-activities'
  | 'center-program-documents-edit'
  | 'center-program-documents-missing-reminder'
  | 'center-teachig-hall'
  | 'host-family'
  | 'coach-companies'
  | 'coach-company-full-view'
  | 'hide-ol-center-columns'
  | 'edit-coach-company'
  | 'edit-mobile-number-for-french-leaders'
  | 'send-email-student-info-to-HF'
  | 'download-enrollment-id-picture'
  | 'print-enrollments-placement-test-results'
  | 'print-enrollments-detailed-test-results'
  | 'download-enrollments-roaster-list'
  | 'print-my-placement-list-by-name-of-student'
  | 'print-my-placement-list-by-name-of-FH'
  | 'print-my-student-list-with-health-problem'
  | 'center-update-retainer-cost'
  | 'create-center-costs-ol-payments'

type OlCenterHeaderKey =
  | 'student-info'
  | 'center-groups'
  | 'center-cost'
  | 'program-and-activities'
  | 'travel-info'
  | 'final-cost'
  | 'events'
  | 'simple-center-cost'
  | 'simple-program-and-activities'
  | 'end-of-stay-appreciations'

type OlPermission = {
  role: RoleEnum
  type?: OLTypeEnum
  productType: ProductTypeEnum[]
}

type OLPermissionsProps = {
  role?: RoleEnum
  type?: OLTypeEnum
  productType?: ProductTypeEnum
}

type OlCenterTabsProps = {
  role?: RoleEnum
  type?: OLTypeEnum
  finalCostVisibility?: boolean
}

type OlPermissions = Record<OlPermissionKeys, OlPermission[]>

export const olPermissions: OlPermissions = {
  'ol-personal-space': [
    {
      role: RoleEnum.ADMIN,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-ol-payments': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'create-center-costs-ol-payments': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-local-organizers': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-host-family': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'ol-teaching-hall-quotation': [
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'ol-teaching-hall-assignment-history': [
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-tefl': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-teaching-hall': [
    { role: RoleEnum.ADMIN, type: OLTypeEnum.LEC, productType: [ProductTypeEnum.NORMAL] },
    { role: RoleEnum.Ol, type: OLTypeEnum.LEC, productType: [ProductTypeEnum.NORMAL] }
  ],
  'center-costs-cultural-outings': [
    { role: RoleEnum.ADMIN, type: OLTypeEnum.LEC, productType: [ProductTypeEnum.NORMAL] },
    { role: RoleEnum.Ol, type: OLTypeEnum.LEC, productType: [ProductTypeEnum.NORMAL] }
  ],
  'center-costs-arrival-departure-transfers': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-french-leader': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-activities': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-miscellaneous': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-total-costs': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-events': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-costs-status': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-program-and-activities': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-program-documents-edit': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-program-documents-missing-reminder': [
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-teachig-hall': [
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'host-family': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'coach-companies': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'coach-company-full-view': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'hide-ol-center-columns': [
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'edit-coach-company': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'edit-mobile-number-for-french-leaders': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'send-email-student-info-to-HF': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'download-enrollment-id-picture': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'print-enrollments-placement-test-results': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'print-enrollments-detailed-test-results': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'download-enrollments-roaster-list': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'print-my-placement-list-by-name-of-student': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'print-my-placement-list-by-name-of-FH': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'print-my-student-list-with-health-problem': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-update-retainer-cost': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ]
}

export function getOlPermissions({
  role,
  type,
  productType
}: Partial<OLPermissionsProps>): Record<OlPermissionKeys, boolean> {
  return Object.keys(olPermissions).reduce(
    (acc, permission) => {
      const p = permission as OlPermissionKeys
      const permissionObject = olPermissions[p]
      const targetPermission = permissionObject.find(
        (perm) =>
          perm.type === type &&
          perm.role === role &&
          (!productType || perm.productType.includes(productType))
      )
      acc[p] = !!targetPermission
      return acc
    },
    {} as Record<OlPermissionKeys, boolean>
  )
}

/**
 * Permissions of a center that can mix several product types (Club 4 and One to One stays):
 * a block is allowed when one of the center product types allows it.
 */
export function getCenterOlPermissions({
  productTypes,
  ...props
}: Omit<Partial<OLPermissionsProps>, 'productType'> & {
  productTypes: ProductTypeEnum[]
}): Record<OlPermissionKeys, boolean> {
  if (productTypes.length === 0) return getOlPermissions(props)

  const permissionsByProductType = productTypes.map((productType) =>
    getOlPermissions({ ...props, productType })
  )
  return Object.keys(olPermissions).reduce(
    (acc, permission) => {
      const p = permission as OlPermissionKeys
      acc[p] = permissionsByProductType.some((permissions) => permissions[p])
      return acc
    },
    {} as Record<OlPermissionKeys, boolean>
  )
}

const olCenterHeaderMapping: Record<OlCenterHeaderKey, OlPermission[]> = {
  'student-info': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-groups': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'center-cost': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'simple-center-cost': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'program-and-activities': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'simple-program-and-activities': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'travel-info': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  'final-cost': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  events: [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.Ol,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ],
  // "Appréciation des jeunes": LEC back office only (no provider-space design)
  'end-of-stay-appreciations': [
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.LEC,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.PARTNER,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    },
    {
      role: RoleEnum.ADMIN,
      type: OLTypeEnum.RESIDENCE,
      productType: [ProductTypeEnum.NORMAL, ProductTypeEnum.ONE_TO_ONE, ProductTypeEnum.CLUB_FOUR]
    }
  ]
}

function olCenterHeaderPermissions({
  role,
  type
}: Partial<OlPermission>): Record<OlCenterHeaderKey, boolean> {
  return Object.keys(olCenterHeaderMapping).reduce(
    (acc, key) => {
      const p = key as OlCenterHeaderKey
      const permissionObject = olCenterHeaderMapping[p]
      const targetPermission = permissionObject.find((p) => p.type === type && p.role === role)

      acc[p] = !!targetPermission
      return acc
    },
    {} as Record<OlCenterHeaderKey, boolean>
  )
}

export function getOlCenterTabs({ role, type, finalCostVisibility }: OlCenterTabsProps) {
  const tabs: { label: LocaleKeys; disabled?: boolean; path: string }[] = []

  const permissions = olCenterHeaderPermissions({ role, type })

  if (permissions['student-info'])
    tabs.push({
      label:
        type === OLTypeEnum.RESIDENCE
          ? 'ol.center.capsule.tabs.placement.and.diffusion.residence'
          : 'ol.center.capsule.tabs.placement.and.diffusion',
      path: Paths.OL_CENTER_PLACEMENTS
    })

  if (permissions['center-groups'])
    tabs.push({
      label: 'ol.center.capsule.tabs.center.groups',
      path: Paths.OL_CENTER_GROUPS
    })

  if (permissions['center-cost'])
    tabs.push({ label: 'ol.center.capsule.tabs.cost.of.center', path: Paths.OL_CENTER_COST })

  if (permissions['simple-center-cost'])
    tabs.push({
      label: 'ol.center.capsule.tabs.simple.cost.of.center',
      path: Paths.OL_CENTER_COST
    })

  if (permissions['program-and-activities'])
    tabs.push({
      label: 'ol.center.capsule.tabs.program.and.activities',
      path: Paths.OL_CENTER_ACTIVITIES_TEFL_AND_TEACHING_HALLS
    })

  if (permissions['simple-program-and-activities']) {
    if (type === OLTypeEnum.RESIDENCE)
      tabs.push({
        label: 'ol.center.capsule.tabs.simple.program.and.center.address',
        path: Paths.OL_CENTER_ACTIVITIES_TEFL_AND_TEACHING_HALLS
      })
    else
      tabs.push({
        label: 'ol.center.capsule.tabs.simple.program.and.teaching.hall',
        path: Paths.OL_CENTER_ACTIVITIES_TEFL_AND_TEACHING_HALLS
      })
  }

  if (permissions['travel-info'])
    tabs.push({
      label: 'ol.center.capsule.tabs.travel.info',
      path: Paths.OL_CENTER_TRIP_INFORMATION
    })

  if (permissions['final-cost'])
    tabs.push({
      label: 'ol.center.capsule.tabs.final.cost',
      disabled: !finalCostVisibility,
      path: Paths.OL_CENTER_FINAL_COST
    })

  if (permissions.events)
    tabs.push({ label: 'ol.center.capsule.tabs.events', path: Paths.OL_CENTER_EVENTS })

  if (permissions['end-of-stay-appreciations'])
    tabs.push({
      label: 'ol.center.capsule.tabs.end.of.stay.appreciations',
      path: Paths.OL_CENTER_END_OF_STAY_APPRECIATIONS
    })

  // add index to the tabs
  return tabs.map((tab, index) => ({ ...tab, index }))
}

type OlTabsKey =
  | 'informations'
  | 'access-rights'
  | 'host-families'
  | 'tefls'
  | 'teaching-halls'
  | 'host-family-prices'
  | 'tarifs'
  | 'activites'
  | 'phone-numbers'
  | 'coach-companies'

type OlHeaderTab = {
  label: string
  path: string
  roles: OlPermission[]
  disabled: ('create' | 'update')[]
}

type OlHeaderProps = {
  role?: RoleEnum
  type?: OLTypeEnum
  mode: 'create' | 'update'
}

const olHeaderMapping: Record<OlTabsKey, OlHeaderTab> = {
  informations: {
    disabled: ['create'],
    label: 'Informations',
    path: Paths.OL_DETAILS_UPDATE_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      },
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.PARTNER,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      },
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.RESIDENCE,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  'access-rights': {
    disabled: ['create'],
    label: `Droit d'accès`,
    path: Paths.OL_DETAILS_ACCESS_RIGHTS_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  'host-families': {
    disabled: ['create'],
    label: 'Familles-hôtesses',
    path: Paths.OL_DETAILS_HOST_FAMILIES_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      },
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.PARTNER,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  tefls: {
    disabled: ['create'],
    label: 'TEFLs',
    path: Paths.OL_DETAILS_TEFLS_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  'teaching-halls': {
    disabled: ['create'],
    label: 'Lieux des cours',
    path: Paths.OL_DETAILS_TEACHING_HALLS_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      },
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.PARTNER,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  'host-family-prices': {
    disabled: ['create'],
    label: 'Rémunération Famille Hôtesse',
    path: Paths.OL_DETAILS_HOST_FAMILY_PRICES_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  tarifs: {
    disabled: ['create'],
    label: 'Tarifs TEFL',
    path: Paths.OL_DETAILS_TEFL_PRICES_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  activites: {
    disabled: ['create'],
    label: 'Activités',
    path: Paths.OL_ACTIVITY_LIST_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  'phone-numbers': {
    disabled: ['create'],
    label: 'Portable du responsable',
    path: Paths.OL_MOBILE_NUMBERS_FOR_FRENCH_LEADERS_LIST_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      },
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.PARTNER,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  },
  'coach-companies': {
    disabled: ['create'],
    label: 'Compagnies de bus',
    path: Paths.OL_COACH_COMPANIES_LIST_PAGE,
    roles: [
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.LEC,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      },
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.RESIDENCE,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      },
      {
        role: RoleEnum.ADMIN,
        type: OLTypeEnum.PARTNER,
        productType: [
          ProductTypeEnum.NORMAL,
          ProductTypeEnum.ONE_TO_ONE,
          ProductTypeEnum.CLUB_FOUR
        ]
      }
    ]
  }
}

export function getOlHeader({
  role,
  type,
  mode
}: OlHeaderProps): { label: string; path: string; disabled: boolean }[] {
  const tabs: { label: string; path: string; disabled: boolean }[] = []

  Object.values(olHeaderMapping).forEach((tab) => {
    const isAllowed = tab.roles.some((r) => r.role === role && r.type === type)

    if (isAllowed) {
      tabs.push({ label: tab.label, path: tab.path, disabled: tab.disabled.includes(mode) })
    }
  })

  return tabs
}
